import React, { useState } from 'react';
import { Search, Filter } from 'lucide-react';
import { CONTINENTS } from '../lib/helpers';
import { Badge } from './ui/badge';

export const SearchAndFilter = ({ onFilterChange, selectedContinent }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onFilterChange({ search: value, continent: selectedContinent });
  };
  
  const handleContinentClick = (continent) => {
    const newContinent = selectedContinent === continent ? null : continent;
    onFilterChange({ search: searchTerm, continent: newContinent });
  };
  
  return (
    <div className="mb-8" data-testid="search-filter-section">
      <div className="relative mb-6">
        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" />
        <input
          type="text"
          placeholder="Buscar destino..."
          value={searchTerm}
          onChange={handleSearch}
          className="w-full h-12 sm:h-14 pl-12 pr-4 rounded-full border-slate-200 focus:border-[#00A8B5] focus:ring-2 focus:ring-[#00A8B5]/20 shadow-sm text-base sm:text-lg"
          data-testid="search-input"
        />
      </div>
      
      <div>
        <div className="flex items-center gap-2 mb-3">
          <Filter className="w-4 h-4 text-slate-600" />
          <span className="text-sm font-medium text-slate-700">Filtrar por continente:</span>
        </div>
        <div className="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
          <Badge
            variant={selectedContinent === null ? "default" : "outline"}
            className="cursor-pointer px-3 py-2 text-xs sm:text-sm justify-center"
            onClick={() => onFilterChange({ search: searchTerm, continent: null })}
            data-testid="filter-all"
          >
            Todos
          </Badge>
          {Object.keys(CONTINENTS).map((continent) => (
            <Badge
              key={continent}
              variant={selectedContinent === continent ? "default" : "outline"}
              className="cursor-pointer px-3 py-2 text-xs sm:text-sm justify-center"
              onClick={() => handleContinentClick(continent)}
              data-testid={`filter-${continent}`}
            >
              {continent}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
};